import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  standalone: false
})
export class OrderByPipe implements PipeTransform {

  transform(objectList: any[], orderByParams:string, reverse:boolean): any[] {
    let sortedArray = objectList.sort((a,b)=>{ return this.comparePropery(a[orderByParams],b[orderByParams])});

    if (reverse){
      return sortedArray.reverse();
    }
    else{
      return sortedArray;
    }
  }

  comparePropery(a:any, b:any) {
    if (a === b) {
      return 0;
    }

    if (a==undefined || a==null || a == '') {
      return 1;
    }

    if (b==undefined || b==null || b == '') {
      return -1;
    }

    if (this.isNumber(a)){
      return a-b;
    }
    else{
      return a.localeCompare(b);
    }
  }

  isNumber(value:any):boolean {
    return typeof value === 'number';
  }
}
